export default {
  flexGrow: 1,
  height: '100%',
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  boxSizing: 'border-box',
};
